<template lang="pug">
  #green-credit
    .container
      .box
        img(class="title-img", :src="getImgUrl('green-credit/green-title')")
        .row
          .credit-balance-container
            img(class="green-counter", :src="getImgUrl('green-credit/green-counter')")
            label.credit-amount.black
              strong {{ smalishGreenCreditsBalance }}
          p.green-credit-desc.grey
            span(v-html="$LANG.green.BALANCE")
            strong {{ lastUpdatedCreditBalanceDate }}
          .button-container
            .item
              router-link(:to="'/' + $LOCALE + '/dashboard'" gtm-label="green-credit.dashboard")
                img.buttons(:src="getImgUrl('btn-home')" gtm-label="green-credit.dashboard")
            .item
              a(href="#" @click="logout" gtm-label="green-credit.logout")
                img.buttons(:src="getImgUrl('btn-logout')" gtm-label="green-credit.logout")
</template>
<script>
  import api from '../library/api.js'
  import dayjs from 'dayjs'

  export default {
    data () {
      return {
        smalishGreenCreditsBalance: 0,
        creditsExpiring: [],
        lastUpdatedCreditBalanceDate: dayjs().format('DD/MM/YYYY')
      }
    },

    created () {
      if (!window.localStorage.getItem('token')) {
        this.$router.push('/' + this.$LOCALE)
      }
    },

    mounted: function () {
      this.getBalance()
    },
    methods: {
      balance (num) {
        return num.toFixed(2)
      },

      getImgUrl (pic) {
        return require('../assets/images/' + pic + '-' + this.$LOCALE + '.png')
      },

      getBalance () {
        api('GetGreenCreditBalance')
          .then(res => {
            res = JSON.parse(res)
            this.smalishGreenCreditsBalance = res.currentBalance
            this.creditsExpiring = res.creditsExpiring
          })
          .catch(err => {
            console.error(err)
            if (err.status === 401 || err.status === 403) {
              window.localStorage.removeItem('token')
              this.$router.push('/' + this.$LOCALE)
            }
          })
      },

      logout () {
        api(`logout?token=${window.localStorage.getItem('token')}`)
        window.localStorage.removeItem('token')
        this.$router.push('/' + this.$LOCALE)
      }
    }
  }
</script>
<style lang="sass" scoped>
  @import "../sass/variables"

  #green-credit
    .black
      color: #555555

    .grey
      color: #666666

    .box
      position: relative
      margin: 0 auto
      padding: 20px
      width: 550px
      height: 100%
      border-radius: 15px
      box-shadow: 0 0 25px #9ecaed
      background-color: #ffffff
      @media #{$mobile}
        width: 100%
        box-shadow: 0 0

    .title-img
      position: absolute
      top: -5%
      right: 4%
      max-width: 300px
      @media #{$mobile}
        position: relative
        left: 50%
        transform: translateX(-50%)
      @media #{$mobile-xs}
        width: 100%

    .credit-balance-container
      position: relative
      +mobile
        margin-top: 20px

    .green-counter
      position: relative
      width: 477px
      left: 50%
      transform: translateX(-50%)
      @media #{$mobile-xs}
        left: 51%
        width: 115%

    .credit-amount
      position: absolute
      top: 50%
      left: 50%
      transform: translateX(0%) translateY(10%)
      font-size: 1.7em
      +mobile
        transform: translateY(-2%)
        font-size: 1.6em

    .green-credit-desc
      text-align: center
      font-size: 1.2em

    .button-container
      text-align: center
      display: flex
      justify-content: center
      img, a
        +desktop
          height: 40px

    .item
      img
        +mobile
          width: 100%
</style>
